import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import Programs from './components/Programs';
import Testimonials from './components/Testimonials';
import Contact from './components/Contact';
import WhatsAppButton from './components/WhatsAppButton';
import Footer from './components/Footer';
import Activities from './components/Activities';
import Admissions from './components/Admissions';
import Faq from './components/Faq';
import LocationSection from './components/LocationSection';
import BlogIndex from './components/BlogIndex';
import SeoSchema from './components/SeoSchema';

function App() {
  return (
    <div className="min-h-screen bg-gray-100 dark:bg-gray-900 transition-colors">
      <SeoSchema />
      <Navbar />
      <Hero />
      <About />
      <Programs />
      <Activities />
      <Admissions />
      <LocationSection />
      <Faq />
      <BlogIndex />
      <Testimonials />
      <Contact />
      <Footer />
      <WhatsAppButton />
    </div>
  );
}

export default App;
